import { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabase";
import "./App.css";

const CITIES = ["北京", "上海", "深圳", "杭州", "广州", "成都", "南京", "武汉", "长沙", "西安"];
const TAGS = ["不劝酒", "老乡局", "不限地域", "90后", "社恐友好", "看春晚", "有桌游", "带娃OK", "素食友好"];
const DIET_OPTS = ["无忌口", "不吃辣", "不吃牛肉", "清真", "素食", "海鲜过敏"];
const DRINK_OPTS = ["能喝一点", "随意", "不喝酒"];
const AGE_OPTS = ["00后", "95后", "90后", "85后", "80后", "70后+"];

const MOCK_RESTAURANTS = {
  "北京": [
    { id: "poi_bj_1", name: "海底捞(中关村店)", addr: "海淀区中关村大街15号", tel: "010-82600123", category: "火锅", distance: "1.2km", lat: 39.9815, lng: 116.3107 },
    { id: "poi_bj_2", name: "眉州东坡(望京店)", addr: "朝阳区望京街9号", tel: "010-64723456", category: "川菜", distance: "2.8km", lat: 39.9960, lng: 116.4803 },
    { id: "poi_bj_3", name: "全聚德(前门店)", addr: "东城区前门大街30号", tel: "010-67011379", category: "烤鸭/京菜", distance: "5.1km", lat: 39.8987, lng: 116.3952 },
    { id: "poi_bj_4", name: "喜家德(五道口店)", addr: "海淀区成府路28号", tel: "010-62780000", category: "饺子", distance: "0.8km", lat: 39.9927, lng: 116.3376 },
    { id: "poi_bj_5", name: "蜀大侠(朝阳店)", addr: "朝阳区建国路88号", tel: "010-85900000", category: "火锅", distance: "4.3km", lat: 39.9087, lng: 116.4724 },
    { id: "poi_bj_6", name: "大董(工体店)", addr: "朝阳区工人体育场东路", tel: "010-65866999", category: "烤鸭/创意菜", distance: "3.6km", lat: 39.9305, lng: 116.4470 },
  ],
  "上海": [
    { id: "poi_sh_1", name: "老正兴(南京路店)", addr: "黄浦区南京东路556号", tel: "021-63223624", category: "本帮菜", distance: "1.5km", lat: 31.2354, lng: 121.4737 },
    { id: "poi_sh_2", name: "小南国(徐汇店)", addr: "徐汇区虹桥路1号", tel: "021-64480000", category: "本帮菜/海鲜", distance: "3.2km", lat: 31.1932, lng: 121.4320 },
    { id: "poi_sh_3", name: "海底捞(静安寺店)", addr: "静安区南京西路1515号", tel: "021-52980000", category: "火锅", distance: "2.0km", lat: 31.2267, lng: 121.4460 },
  ],
  "深圳": [
    { id: "poi_sz_1", name: "潮汕牛肉火锅(南山店)", addr: "南山区科技园路2号", tel: "0755-86000123", category: "火锅/潮汕菜", distance: "1.0km", lat: 22.5430, lng: 113.9530 },
    { id: "poi_sz_2", name: "椰客(福田店)", addr: "福田区华强北路100号", tel: "0755-82000456", category: "椰子鸡/海南菜", distance: "2.5km", lat: 22.5470, lng: 114.0895 },
  ],
};

Object.keys(MOCK_RESTAURANTS).forEach(city => {
  if (!MOCK_RESTAURANTS[city]) MOCK_RESTAURANTS[city] = [];
});

const AVATARS = ["😊","🤓","😄","🥰","😎","🧑","👧","👦","🤗","😆","🥳","🧔","👨","👩","🤠","🦊"];
function hashAvatar(name) {
  let h = 0;
  for (let i = 0; i < (name||"").length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  return AVATARS[Math.abs(h) % AVATARS.length];
}

function useCountdown() {
  const [diff, setDiff] = useState(0);
  useEffect(() => {
    const target = new Date("2026-02-16T18:00:00+08:00").getTime();
    const tick = () => setDiff(Math.max(0, target - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
  const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
  const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
  return { h, m, s };
}

function TagChip({ label, selected, onClick, small }) {
  return (
    <button onClick={onClick} style={{ 
      padding: small ? "5px 12px" : "7px 15px", 
      borderRadius: 20, 
      border: "1px solid", 
      borderColor: selected ? "#C41E24" : "#E8D5C0", 
      background: selected ? "#C41E24" : "#FDF6EC", 
      color: selected ? "#fff" : "#6B5344", 
      fontSize: small ? 12 : 13, 
      cursor: "pointer", 
      fontFamily: "inherit", 
      transition: "all 0.2s", 
      whiteSpace: "nowrap" 
    }}>{label}</button>
  );
}

function DinnerCard({ dinner, onClick }) {
  const seatsLeft = dinner.max_people - (dinner.members?.length || 0);
  const isFull = seatsLeft <= 0;
  const isHot = seatsLeft <= 2 && !isFull;
  
  return (
    <div onClick={onClick} style={{ 
      background: "#fff", 
      borderRadius: 16, 
      padding: 16, 
      boxShadow: "0 2px 12px rgba(45,27,16,0.08)", 
      cursor: "pointer", 
      transition: "transform 0.2s", 
      marginBottom: 12 
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div style={{ fontFamily: "'Noto Serif SC',serif", fontSize: 16, fontWeight: 700, flex: 1 }}>{dinner.title}</div>
        {isFull ? 
          <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#f0f0f0", color: "#999" }}>已满</span> : 
          isHot ? 
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#FEE7E7", color: "#C41E24" }}>🔥 快满了</span> : 
            <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#E7F5EE", color: "#2D8B5F" }}>报名中</span>
        }
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, fontSize: 13, color: "#6B5344", marginBottom: 10 }}>
        <span>📍 {dinner.restaurant_name || "待定"}</span>
        <span>📅 {dinner.dinner_date}</span>
        <span>💰 ~{dinner.price_range}/人</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex" }}>
          {(dinner.members || []).slice(0, 7).map((m, i) => (
            <div key={i} style={{ 
              width: 26, 
              height: 26, 
              borderRadius: "50%", 
              border: "2px solid #fff", 
              marginLeft: i > 0 ? -7 : 0, 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              fontSize: 13, 
              background: "#FDF6EC" 
            }}>{hashAvatar(m.nickname)}</div>
          ))}
          {(dinner.members?.length || 0) > 7 && (
            <div style={{ 
              width: 26, 
              height: 26, 
              borderRadius: "50%", 
              border: "2px solid #fff", 
              marginLeft: -7, 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              fontSize: 10, 
              background: "#FDF6EC", 
              color: "#9A8576" 
            }}>+{dinner.members.length - 7}</div>
          )}
        </div>
        <div style={{ 
          fontSize: 12, 
          color: isFull ? "#999" : seatsLeft <= 2 ? "#D4A532" : "#C41E24", 
          fontWeight: 500 
        }}>
          {isFull ? "已满员" : seatsLeft <= 2 ? `仅剩${seatsLeft}席！` : `还剩${seatsLeft}席`}
        </div>
      </div>
    </div>
  );
}

function NavBar({ title, onBack }) {
  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      padding: "12px 16px", 
      background: "#fff", 
      borderBottom: "1px solid #E8D5C0", 
      position: "sticky", 
      top: 0, 
      zIndex: 100 
    }}>
      <button onClick={onBack} style={{ 
        width: 32, 
        height: 32, 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
        fontSize: 20, 
        cursor: "pointer", 
        border: "none", 
        background: "none", 
        color: "#2D1B10" 
      }}>←</button>
      <div style={{ flex: 1, textAlign: "center", fontWeight: 600, fontSize: 16 }}>{title}</div>
      <div style={{ width: 32 }}></div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ 
      background: "#fff", 
      margin: "0 16px 12px", 
      borderRadius: 16, 
      padding: 16, 
      boxShadow: "0 2px 12px rgba(45,27,16,0.08)" 
    }}>
      <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }}>{title}</h3>
      {children}
    </div>
  );
}

function FormSection({ title, children }) {
  return (
    <div style={{ 
      background: "#fff", 
      borderRadius: 16, 
      padding: 18, 
      marginBottom: 12, 
      boxShadow: "0 2px 12px rgba(45,27,16,0.08)" 
    }}>
      <div style={{ fontWeight: 600, fontSize: 14, color: "#2D1B10", marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>{title}</div>
      {children}
    </div>
  );
}

function FormField({ label, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 12, color: "#6B5344", marginBottom: 5, display: "block" }}>{label}</label>
      {children}
    </div>
  );
}

function HomeScreen({ onGo, dinners }) {
  const { h, m, s } = useCountdown();
  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ 
        position: "relative", 
        background: "linear-gradient(135deg,#C41E24,#8B1A1F)", 
        padding: "44px 24px 52px", 
        textAlign: "center", 
        overflow: "hidden" 
      }}>
        <div style={{ 
          position: "absolute", 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center" 
        }}>
          <span style={{ 
            fontSize: 160, 
            fontFamily: "'Noto Serif SC',serif", 
            color: "rgba(255,255,255,0.03)", 
            fontWeight: 900, 
            transform: "rotate(-12deg)" 
          }}>福</span>
        </div>
        <div style={{ position: "absolute", top: 10, left: 20, fontSize: 28, opacity: 0.5 }}>🏮</div>
        <div style={{ position: "absolute", top: 10, right: 20, fontSize: 28, opacity: 0.5 }}>🏮</div>
        <h1 style={{ 
          fontFamily: "'Noto Serif SC',serif", 
          fontSize: 32, 
          fontWeight: 900, 
          color: "#F0D68A", 
          letterSpacing: 3, 
          textShadow: "0 2px 12px rgba(0,0,0,0.3)", 
          position: "relative" 
        }}>异乡团圆</h1>
        <p style={{ 
          color: "rgba(255,255,255,0.85)", 
          fontSize: 15, 
          marginTop: 8, 
          fontWeight: 300, 
          position: "relative" 
        }}>他乡亦故乡 · 明天除夕，今晚约起</p>
      </div>
      
      <div style={{ 
        background: "#fff", 
        margin: "-20px 16px 16px", 
        borderRadius: 16, 
        padding: "16px 20px", 
        boxShadow: "0 8px 32px rgba(45,27,16,0.12)", 
        position: "relative", 
        zIndex: 10, 
        textAlign: "center" 
      }}>
        <div style={{ fontSize: 13, color: "#9A8576", marginBottom: 8 }}>距除夕年夜饭倒计时</div>
        <div style={{ display: "flex", justifyContent: "center", gap: 8, alignItems: "center" }}>
          {[h, m, s].map((v, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ 
                background: "#C41E24", 
                color: "#F0D68A", 
                fontFamily: "'Noto Serif SC',serif", 
                fontSize: 24, 
                fontWeight: 700, 
                padding: "8px 14px", 
                borderRadius: 8, 
                minWidth: 48, 
                textAlign: "center" 
              }}>{v}</div>
              {i < 2 && <span style={{ color: "#C41E24", fontSize: 20, fontWeight: 700 }}>:</span>}
            </div>
          ))}
        </div>
        <div style={{ fontSize: 12, color: "#9A8576", marginTop: 8 }}>别一个人过年了 🧧</div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, padding: "0 16px", marginBottom: 20 }}>
        <button onClick={() => onGo("create")} style={{ 
          border: "none", 
          borderRadius: 16, 
          padding: "22px 16px", 
          cursor: "pointer", 
          textAlign: "left", 
          background: "linear-gradient(135deg,#C41E24,#E8454B)", 
          color: "#fff", 
          gridColumn: "1/-1", 
          fontFamily: "inherit" 
        }}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>🥘</div>
          <div style={{ fontSize: 17, fontWeight: 600 }}>我来做东 · 发起团圆饭</div>
          <div style={{ fontSize: 12, opacity: 0.8, marginTop: 3 }}>选餐厅、定人数、AA制，3分钟搞定</div>
        </button>
        <button onClick={() => onGo("list")} style={{ 
          border: "none", 
          borderRadius: 16, 
          padding: "18px 14px", 
          cursor: "pointer", 
          textAlign: "left", 
          background: "#fff", 
          boxShadow: "0 2px 12px rgba(45,27,16,0.08)", 
          fontFamily: "inherit" 
        }}>
          <div style={{ fontSize: 24, marginBottom: 4 }}>🔍</div>
          <div style={{ fontSize: 15, fontWeight: 600 }}>找饭局</div>
          <div style={{ fontSize: 11, color: "#9A8576", marginTop: 2 }}>浏览并加入团圆饭</div>
        </button>
        <button onClick={() => onGo("my")} style={{ 
          border: "none", 
          borderRadius: 16, 
          padding: "18px 14px", 
          cursor: "pointer", 
          textAlign: "left", 
          background: "#fff", 
          boxShadow: "0 2px 12px rgba(45,27,16,0.08)", 
          fontFamily: "inherit" 
        }}>
          <div style={{ fontSize: 24, marginBottom: 4 }}>👤</div>
          <div style={{ fontSize: 15, fontWeight: 600 }}>我的</div>
          <div style={{ fontSize: 11, color: "#9A8576", marginTop: 2 }}>我参加的饭局</div>
        </button>
      </div>

      <div style={{ 
        padding: "0 16px", 
        fontFamily: "'Noto Serif SC',serif", 
        fontSize: 18, 
        fontWeight: 700, 
        marginBottom: 12, 
        display: "flex", 
        alignItems: "center", 
        gap: 8 
      }}>
        <span style={{ width: 4, height: 20, background: "#C41E24", borderRadius: 2, display: "inline-block" }}></span>
        最新饭局
      </div>
      <div style={{ padding: "0 16px" }}>
        {dinners.slice(0, 5).map(d => (
          <DinnerCard key={d.id} dinner={d} onClick={() => onGo("detail", d.id)} />
        ))}
      </div>
      <div style={{ height: 24 }}></div>
    </div>
  );
}

function ListScreen({ onGo, onBack, dinners }) {
  const [city, setCity] = useState("全部");
  const [search, setSearch] = useState("");
  
  const filtered = dinners.filter(d => {
    if (city !== "全部" && d.city !== city) return false;
    if (search && !d.title.includes(search) && !d.restaurant_name?.includes(search)) return false;
    return true;
  });

  return (
    <div style={{ minHeight: "100vh" }}>
      <NavBar title="找团圆饭" onBack={onBack} />
      <div style={{ padding: "12px 16px" }}>
        <input 
          value={search} 
          onChange={e => setSearch(e.target.value)} 
          placeholder="🔍 搜索饭局名称或餐厅..." 
          style={{ 
            width: "100%", 
            padding: 11, 
            border: "1px solid #E8D5C0", 
            borderRadius: 24, 
            fontSize: 14, 
            fontFamily: "inherit", 
            background: "#fff", 
            outline: "none" 
          }} 
        />
      </div>
      <div style={{ display: "flex", gap: 7, padding: "0 16px", marginBottom: 14, overflowX: "auto" }}>
        {["全部", ...CITIES.slice(0, 6)].map(c => (
          <TagChip key={c} label={c} selected={city === c} onClick={() => setCity(c)} small />
        ))}
      </div>
      <div style={{ padding: "0 16px" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: "#9A8576" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🍽️</div>
            <div>该城市暂无饭局</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>来做第一个发起人吧！</div>
          </div>
        ) : filtered.map(d => (
          <DinnerCard key={d.id} dinner={d} onClick={() => onGo("detail", d.id)} />
        ))}
      </div>
      <div style={{ height: 24 }}></div>
    </div>
  );
}

function DetailScreen({ onGo, onBack, dinner, onJoin, myProfile }) {
  if (!dinner) return <div style={{ padding: 40, textAlign: "center" }}>饭局不存在</div>;
  
  const seatsLeft = dinner.max_people - (dinner.members?.length || 0);
  const isFull = seatsLeft <= 0;
  const alreadyJoined = myProfile && dinner.members?.some(m => m.nickname === myProfile.nickname);

  return (
    <div style={{ minHeight: "100vh", paddingBottom: 80 }}>
      <NavBar title="饭局详情" onBack={onBack} />
      <div style={{ 
        background: "linear-gradient(135deg,#C41E24,#8B1A1F)", 
        padding: "28px 20px", 
        textAlign: "center", 
        position: "relative", 
        overflow: "hidden" 
      }}>
        <span style={{ 
          position: "absolute", 
          fontSize: 80, 
          fontFamily: "'Noto Serif SC',serif", 
          color: "rgba(255,255,255,0.03)", 
          top: "50%", 
          left: "50%", 
          transform: "translate(-50%,-50%)", 
          fontWeight: 900 
        }}>團圓</span>
        <h2 style={{ 
          fontFamily: "'Noto Serif SC',serif", 
          fontSize: 21, 
          color: "#F0D68A", 
          fontWeight: 700, 
          position: "relative" 
        }}>{dinner.title}</h2>
        <div style={{ 
          color: "rgba(255,255,255,0.8)", 
          fontSize: 13, 
          marginTop: 6, 
          position: "relative" 
        }}>
          发起人：{dinner.host_nickname} · {dinner.host_hometown}
        </div>
      </div>

      <div style={{ 
        background: "#fff", 
        margin: "-12px 16px 12px", 
        borderRadius: 16, 
        padding: 16, 
        boxShadow: "0 8px 32px rgba(45,27,16,0.12)", 
        position: "relative", 
        zIndex: 10 
      }}>
        {[
          { icon: "📅", label: "时间", value: dinner.dinner_date },
          { icon: "📍", label: "餐厅", value: `${dinner.restaurant_name || "待定"} ${dinner.restaurant_addr || ""}` },
          { icon: "👥", label: "人数", value: `${dinner.max_people}人桌 · 已报名${dinner.members?.length || 0}人 · 还剩${seatsLeft}席` },
          { icon: "💰", label: "费用", value: `AA制 · 预估 ${dinner.price_range}/人` },
        ].map((row, i) => (
          <div key={i} style={{ 
            display: "flex", 
            alignItems: "flex-start", 
            padding: "10px 0", 
            borderBottom: i < 3 ? "1px solid #FDF6EC" : "none", 
            gap: 10 
          }}>
            <span style={{ fontSize: 16, width: 22, textAlign: "center", flexShrink: 0, marginTop: 2 }}>{row.icon}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, color: "#9A8576" }}>{row.label}</div>
              <div style={{ fontSize: 14, color: "#2D1B10", fontWeight: 500, marginTop: 1, whiteSpace: "pre-line" }}>{row.value}</div>
            </div>
          </div>
        ))}
        {dinner.tags?.length > 0 && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
            {dinner.tags.map(t => <span key={t} style={{ fontSize: 12, padding: "2px 8px", background: "#FDF6EC", borderRadius: 6 }}>{t}</span>)}
          </div>
        )}
      </div>

      {dinner.description && (
        <Section title="💬 发起人说">
          <p style={{ fontSize: 14, color: "#6B5344", lineHeight: 1.8 }}>{dinner.description}</p>
        </Section>
      )}

      <Section title={`👥 已报名 (${dinner.members?.length || 0}/${dinner.max_people})`}>
        {(dinner.members || []).map((m, i) => (
          <div key={i} style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 10, 
            padding: 8, 
            background: "#FDF6EC", 
            borderRadius: 10, 
            marginBottom: 8 
          }}>
            <div style={{ 
              width: 36, 
              height: 36, 
              borderRadius: "50%", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              fontSize: 18, 
              background: "#fff" 
            }}>{hashAvatar(m.nickname)}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{m.nickname}</div>
              <div style={{ fontSize: 11, color: "#9A8576", display: "flex", gap: 8, marginTop: 1 }}>
                <span>{m.hometown}</span>
                {m.industry && <span>{m.industry}</span>}
              </div>
              {m.intro && <div style={{ fontSize: 11, color: "#9A8576", marginTop: 2 }}>"{m.intro}"</div>}
            </div>
            {m.is_host && <span style={{ fontSize: 11, padding: "1px 6px", borderRadius: 6, background: "#FEE7E7", color: "#C41E24" }}>发起人</span>}
          </div>
        ))}
      </Section>

      <Section title="📋 饭局公约">
        {["费用AA，饭后按实际消费均摊", "准时到场，有事提前群里说", "尊重每位参与者，友善交流", "不强制劝酒，饮酒自愿", "拍照发圈前请征得同意"].map((r, i) => (
          <div key={i} style={{ fontSize: 13, color: "#6B5344", lineHeight: 2, paddingLeft: 18, position: "relative" }}>
            <span style={{ position: "absolute", left: 0, color: "#C41E24", fontWeight: 700 }}>✓</span>{r}
          </div>
        ))}
      </Section>

      <div style={{ 
        position: "fixed", 
        bottom: 0, 
        left: "50%", 
        transform: "translateX(-50%)", 
        width: "100%", 
        maxWidth: 430, 
        background: "#fff", 
        padding: "12px 16px", 
        borderTop: "1px solid #E8D5C0", 
        display: "flex", 
        gap: 12, 
        alignItems: "center", 
        zIndex: 100 
      }}>
        <div style={{ fontFamily: "'Noto Serif SC',serif", textAlign: "center", minWidth: 72 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#C41E24" }}>≈¥{dinner.price_range?.split("~")[0] || "?"}</div>
          <div style={{ fontSize: 11, color: "#9A8576" }}>预估/人</div>
        </div>
        <button 
          onClick={() => { if (alreadyJoined || isFull) return; onGo("join", dinner.id); }}
          style={{ 
            flex: 1, 
            padding: 14, 
            border: "none", 
            borderRadius: 12, 
            background: alreadyJoined ? "#E7F5EE" : isFull ? "#f0f0f0" : "linear-gradient(135deg,#C41E24,#E8454B)", 
            color: alreadyJoined ? "#2D8B5F" : isFull ? "#999" : "#fff", 
            fontSize: 16, 
            fontWeight: 600, 
            fontFamily: "inherit", 
            cursor: alreadyJoined || isFull ? "default" : "pointer" 
          }}
        >
          {alreadyJoined ? "✅ 已报名" : isFull ? "已满员" : "🎉 我要入席"}
        </button>
      </div>
    </div>
  );
}

function JoinScreen({ onBack, dinner, onSubmit }) {
  const [form, setForm] = useState({ 
    nickname: "", 
    gender: "", 
    hometown: "", 
    age: "90后", 
    industry: "", 
    intro: "", 
    diet: "无忌口", 
    drink: "随意", 
    wechat: "", 
    phone: "" 
  });
  
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));
  const canSubmit = form.nickname && form.hometown && form.wechat;

  return (
    <div style={{ minHeight: "100vh" }}>
      <NavBar title="报名入席" onBack={onBack} />
      <div style={{ padding: 16 }}>
        <div style={{ 
          background: "#FFF8E7", 
          border: "1px solid #D4A532", 
          borderRadius: 10, 
          padding: 12, 
          fontSize: 12, 
          color: "#6B5344", 
          lineHeight: 1.6, 
          display: "flex", 
          gap: 8, 
          marginBottom: 12 
        }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>🔒</span>
          <span>你的微信号和手机号仅发起人可见，用于拉你入群。其他参与者只能看到昵称和简介。</span>
        </div>
        
        <FormSection title="👤 基本信息">
          <FormField label="昵称 *">
            <input className="fi" value={form.nickname} onChange={e => set("nickname", e.target.value)} placeholder="你希望大家怎么称呼你" />
          </FormField>
          <FormField label="性别">
            <div style={{ display: "flex", gap: 7 }}>
              {["男", "女", "保密"].map(g => <TagChip key={g} label={g} selected={form.gender === g} onClick={() => set("gender", g)} small />)}
            </div>
          </FormField>
          <FormField label="年龄段">
            <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
              {AGE_OPTS.map(a => <TagChip key={a} label={a} selected={form.age === a} onClick={() => set("age", a)} small />)}
            </div>
          </FormField>
          <FormField label="家乡 *">
            <input className="fi" value={form.hometown} onChange={e => set("hometown", e.target.value)} placeholder="如：湖南长沙" />
          </FormField>
        </FormSection>

        <FormSection title="💬 让大家认识你">
          <FormField label="职业/行业">
            <input className="fi" value={form.industry} onChange={e => set("industry", e.target.value)} placeholder="如：互联网产品经理" />
          </FormField>
          <FormField label="一句话介绍自己">
            <input className="fi" value={form.intro} onChange={e => set("intro", e.target.value)} placeholder="如：爱吃辣的社恐人🌶️" />
          </FormField>
          <FormField label="饮食偏好">
            <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
              {DIET_OPTS.map(d => <TagChip key={d} label={d} selected={form.diet === d} onClick={() => set("diet", d)} small />)}
            </div>
          </FormField>
          <FormField label="饮酒态度">
            <div style={{ display: "flex", gap: 7 }}>
              {DRINK_OPTS.map(d => <TagChip key={d} label={d} selected={form.drink === d} onClick={() => set("drink", d)} small />)}
            </div>
          </FormField>
        </FormSection>

        <FormSection title="📱 联系方式（仅发起人可见）">
          <FormField label="微信号 *">
            <input className="fi" value={form.wechat} onChange={e => set("wechat", e.target.value)} placeholder="发起人通过微信拉你入群" />
          </FormField>
          <FormField label="手机号">
            <input className="fi" type="tel" value={form.phone} onChange={e => set("phone", e.target.value)} placeholder="紧急联系备用" />
          </FormField>
        </FormSection>

        <button 
          onClick={() => canSubmit && onSubmit(form)} 
          style={{ 
            width: "100%", 
            padding: 15, 
            border: "none", 
            borderRadius: 16, 
            background: canSubmit ? "linear-gradient(135deg,#C41E24,#E8454B)" : "#E8D5C0", 
            color: canSubmit ? "#fff" : "#9A8576", 
            fontSize: 16, 
            fontWeight: 600, 
            fontFamily: "inherit", 
            cursor: canSubmit ? "pointer" : "default" 
          }}
        >✅ 确认报名 · 除夕见！</button>
        <div style={{ height: 20 }}></div>
      </div>
    </div>
  );
}

function CreateScreen({ onBack, onSubmit }) {
  const [form, setForm] = useState({ 
    title: "", 
    city: "北京", 
    restaurantSearch: "", 
    restaurant: null, 
    date: "除夕 18:00", 
    maxPeople: 8, 
    priceRange: "80~120元", 
    tags: ["不劝酒"], 
    desc: "", 
    nickname: "", 
    hometown: "", 
    wechat: "" 
  });
  
  const [showPOI, setShowPOI] = useState(false);
  const [poiResults, setPoiResults] = useState([]);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const searchPOI = (query) => {
    set("restaurantSearch", query);
    if (!query) { setPoiResults([]); return; }
    const cityPOIs = MOCK_RESTAURANTS[form.city] || [];
    const all = [...cityPOIs, ...(MOCK_RESTAURANTS["北京"] || [])];
    const results = all.filter(p => p.name.includes(query) || p.category.includes(query) || p.addr.includes(query));
    setPoiResults(results.length > 0 ? results : all.slice(0, 4));
    setShowPOI(true);
  };

  const canSubmit = form.title && form.restaurant && form.nickname && form.wechat;

  return (
    <div style={{ minHeight: "100vh" }}>
      <NavBar title="发起团圆饭" onBack={onBack} />
      <div style={{ padding: 16 }}>
        <FormSection title="🍽️ 饭局信息">
          <FormField label="饭局名称 *">
            <input className="fi" value={form.title} onChange={e => set("title", e.target.value)} placeholder="如：湘味年夜饭·老乡局" />
          </FormField>
          <FormField label="城市 *">
            <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
              {CITIES.slice(0, 6).map(c => (
                <TagChip 
                  key={c} 
                  label={c} 
                  selected={form.city === c} 
                  onClick={() => { set("city", c); set("restaurant", null); set("restaurantSearch", ""); }} 
                  small 
                />
              ))}
            </div>
          </FormField>
          <FormField label="搜索附近餐厅 *（模拟地图POI）">
            <input 
              className="fi" 
              value={form.restaurantSearch} 
              onChange={e => searchPOI(e.target.value)} 
              onFocus={() => { if (!form.restaurantSearch) searchPOI("火锅"); }}
              placeholder="输入餐厅名/菜系，如：火锅、饺子..." 
            />
            <div style={{ fontSize: 11, color: "#9A8576", marginTop: 3 }}>
              🗺️ 接入腾讯/高德地图SDK，搜索 {form.city} 附近餐饮POI
            </div>
            {showPOI && poiResults.length > 0 && (
              <div style={{ marginTop: 8, border: "1px solid #E8D5C0", borderRadius: 12, overflow: "hidden", background: "#fff" }}>
                {poiResults.map(poi => (
                  <div 
                    key={poi.id} 
                    onClick={() => { set("restaurant", poi); set("restaurantSearch", poi.name); setShowPOI(false); }}
                    style={{ 
                      padding: "10px 12px", 
                      borderBottom: "1px solid #FDF6EC", 
                      cursor: "pointer", 
                      display: "flex", 
                      gap: 10, 
                      alignItems: "flex-start" 
                    }}
                  >
                    <span style={{ fontSize: 20 }}>📍</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 500 }}>{poi.name}</div>
                      <div style={{ fontSize: 11, color: "#9A8576", marginTop: 2 }}>{poi.addr} · {poi.category} · {poi.distance}</div>
                    </div>
                  </div>
                ))}
                <div style={{ padding: "8px 12px", fontSize: 11, color: "#9A8576", textAlign: "center", background: "#FDF6EC" }}>
                  💡 可跳转美团/大众点评查看详细评分和菜单
                </div>
              </div>
            )}
          </FormField>
          {form.restaurant && (
            <div style={{ background: "#E7F5EE", borderRadius: 10, padding: 12, display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{ fontSize: 20 }}>✅</span>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{form.restaurant.name}</div>
                <div style={{ fontSize: 11, color: "#6B5344" }}>{form.restaurant.addr} · {form.restaurant.tel}</div>
              </div>
            </div>
          )}
          <FormField label="开饭时间">
            <select className="fi" value={form.date} onChange={e => set("date", e.target.value)}>
              {["除夕 17:00", "除夕 17:30", "除夕 18:00", "除夕 18:30", "除夕 19:00", "初一 12:00", "初一 18:00"].map(d => <option key={d}>{d}</option>)}
            </select>
          </FormField>
          <FormField label="人数上限">
            <select className="fi" value={form.maxPeople} onChange={e => set("maxPeople", +e.target.value)}>
              {[4, 6, 8, 10, 12].map(n => <option key={n} value={n}>{n}人</option>)}
            </select>
          </FormField>
          <FormField label="预估人均">
            <select className="fi" value={form.priceRange} onChange={e => set("priceRange", e.target.value)}>
              {["50元以下", "50~80元", "80~120元", "120~200元", "200元以上"].map(p => <option key={p}>{p}</option>)}
            </select>
          </FormField>
        </FormSection>

        <FormSection title="🏷️ 饭局氛围">
          <FormField label="标签（可多选）">
            <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
              {TAGS.map(t => (
                <TagChip 
                  key={t} 
                  label={t} 
                  selected={form.tags.includes(t)} 
                  onClick={() => { set("tags", form.tags.includes(t) ? form.tags.filter(x => x !== t) : [...form.tags, t]); }} 
                  small 
                />
              ))}
            </div>
          </FormField>
          <FormField label="写几句话描述这顿饭">
            <textarea 
              className="fi" 
              value={form.desc} 
              onChange={e => set("desc", e.target.value)} 
              placeholder="告诉大家你是谁、为什么组局、饭局氛围..." 
              style={{ minHeight: 80, resize: "none" }} 
            />
          </FormField>
        </FormSection>

        <FormSection title="👤 你的信息">
          <FormField label="你的昵称 *">
            <input className="fi" value={form.nickname} onChange={e => set("nickname", e.target.value)} placeholder="群里大家怎么叫你" />
          </FormField>
          <FormField label="你的家乡">
            <input className="fi" value={form.hometown} onChange={e => set("hometown", e.target.value)} placeholder="如：湖南长沙" />
          </FormField>
          <FormField label="你的微信号 *">
            <input className="fi" value={form.wechat} onChange={e => set("wechat", e.target.value)} placeholder="报名者需要加你微信入群" />
          </FormField>
        </FormSection>

        <button 
          onClick={() => canSubmit && onSubmit(form)} 
          style={{ 
            width: "100%", 
            padding: 15, 
            border: "none", 
            borderRadius: 16, 
            background: canSubmit ? "linear-gradient(135deg,#C41E24,#E8454B)" : "#E8D5C0", 
            color: canSubmit ? "#fff" : "#9A8576", 
            fontSize: 16, 
            fontWeight: 600, 
            fontFamily: "inherit", 
            cursor: canSubmit ? "pointer" : "default" 
          }}
        >🎉 发布团圆饭</button>
        <div style={{ height: 20 }}></div>
      </div>
    </div>
  );
}

function SuccessScreen({ type, dinner, onHome }) {
  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center", 
      minHeight: "100vh", 
      padding: "40px 24px", 
      textAlign: "center", 
      background: "linear-gradient(180deg,#FDF6EC,#fff)" 
    }}>
      <div style={{ fontSize: 72, marginBottom: 20 }}>🎊</div>
      <div style={{ fontFamily: "'Noto Serif SC',serif", fontSize: 24, fontWeight: 700, color: "#C41E24", marginBottom: 8 }}>
        {type === "join" ? "报名成功！" : "饭局发布成功！"}
      </div>
      <div style={{ fontSize: 14, color: "#6B5344", marginBottom: 28, lineHeight: 1.7 }}>
        {type === "join" ? (
          <>你已成功入席「{dinner?.title}」<br />发起人会通过微信拉你入群<br />除夕见！🧧</>
        ) : (
          <>你的团圆饭已上线<br />其他异乡人可以看到并报名了<br />分享出去让更多人看到！</>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%", maxWidth: 280 }}>
        <button 
          onClick={onHome} 
          style={{ 
            padding: 13, 
            borderRadius: 12, 
            fontSize: 15, 
            fontWeight: 600, 
            fontFamily: "inherit", 
            cursor: "pointer", 
            border: "none", 
            background: "linear-gradient(135deg,#C41E24,#E8454B)", 
            color: "#fff" 
          }}
        >🏠 返回首页</button>
      </div>
    </div>
  );
}

function MyScreen({ onBack, onGo, dinners, myProfile }) {
  const myDinners = myProfile ? dinners.filter(d => d.members?.some(m => m.nickname === myProfile.nickname)) : [];
  
  return (
    <div style={{ minHeight: "100vh" }}>
      <NavBar title="我的饭局" onBack={onBack} />
      {myProfile ? (
        <div style={{ padding: 16 }}>
          <div style={{ 
            background: "#fff", 
            borderRadius: 16, 
            padding: 16, 
            boxShadow: "0 2px 12px rgba(45,27,16,0.08)", 
            marginBottom: 16, 
            display: "flex", 
            gap: 12, 
            alignItems: "center" 
          }}>
            <div style={{ 
              width: 48, 
              height: 48, 
              borderRadius: "50%", 
              background: "#FDF6EC", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              fontSize: 24 
            }}>{hashAvatar(myProfile.nickname)}</div>
            <div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>{myProfile.nickname}</div>
              <div style={{ fontSize: 12, color: "#9A8576" }}>{myProfile.hometown} · {myProfile.industry || "未填写行业"}</div>
            </div>
          </div>
          {myDinners.length === 0 ? (
            <div style={{ textAlign: "center", padding: 40, color: "#9A8576" }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🍽️</div>
              <div>你还没有参加任何饭局</div>
              <button 
                onClick={() => onGo("list")} 
                style={{ 
                  marginTop: 12, 
                  padding: "10px 24px", 
                  borderRadius: 20, 
                  border: "1px solid #C41E24", 
                  background: "none", 
                  color: "#C41E24", 
                  fontFamily: "inherit", 
                  cursor: "pointer" 
                }}
              >去找饭局</button>
            </div>
          ) : (
            myDinners.map(d => <DinnerCard key={d.id} dinner={d} onClick={() => onGo("detail", d.id)} />)
          )}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: 40, color: "#9A8576" }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>👤</div>
          <div>报名或发起饭局后，这里会显示你的信息</div>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [screen, setScreen] = useState("home");
  const [targetId, setTargetId] = useState(null);
  const [dinners, setDinners] = useState([]);
  const [myProfile, setMyProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successType, setSuccessType] = useState(null);
  const [successDinner, setSuccessDinner] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadDinners();
    loadMyProfile();
  }, []);

  async function loadDinners() {
    try {
      const { data, error } = await supabase
        .from('dinners')
        .select(`
          *,
          members:members(*)
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;
      setDinners(data || []);
    } catch (e) {
      console.error('加载饭局失败:', e);
      setError('数据库连接失败，请检查 Supabase 配置');
    } finally {
      setLoading(false);
    }
  }

  async function loadMyProfile() {
    const saved = localStorage.getItem('my_profile_v2');
    if (saved) setMyProfile(JSON.parse(saved));
  }

  const go = useCallback((s, id) => {
    setScreen(s);
    setTargetId(id || null);
    window.scrollTo(0, 0);
  }, []);

  const handleJoinSubmit = async (form) => {
    const dinner = dinners.find(d => d.id === targetId);
    if (!dinner) return;

    try {
      const newMember = {
        dinner_id: targetId,
        nickname: form.nickname,
        gender: form.gender,
        hometown: form.hometown,
        age_range: form.age,
        industry: form.industry,
        intro: form.intro,
        diet: form.diet,
        drink: form.drink,
        wechat: form.wechat,
        phone: form.phone,
        is_host: false
      };

      const { error } = await supabase.from('members').insert(newMember);
      if (error) throw error;

      await loadDinners();

      const profile = { nickname: form.nickname, hometown: form.hometown, industry: form.industry };
      setMyProfile(profile);
      localStorage.setItem('my_profile_v2', JSON.stringify(profile));

      setSuccessType("join");
      setSuccessDinner(dinner);
      go("success");
    } catch (e) {
      console.error('报名失败:', e);
      alert('报名失败: ' + e.message);
    }
  };

  const handleCreateSubmit = async (form) => {
    try {
      const newDinner = {
        title: form.title,
        city: form.city,
        restaurant_name: form.restaurant?.name,
        restaurant_addr: form.restaurant?.addr,
        restaurant_tel: form.restaurant?.tel,
        restaurant_lat: form.restaurant?.lat,
        restaurant_lng: form.restaurant?.lng,
        dinner_date: form.date,
        max_people: form.maxPeople,
        price_range: form.priceRange,
        tags: form.tags,
        description: form.desc,
        host_nickname: form.nickname,
        host_hometown: form.hometown,
        host_wechat: form.wechat
      };

      const { data, error } = await supabase.from('dinners').insert(newDinner).select();
      if (error) throw error;

      const dinnerId = data[0].id;

      const hostMember = {
        dinner_id: dinnerId,
        nickname: form.nickname,
        hometown: form.hometown,
        intro: "",
        is_host: true
      };

      await supabase.from('members').insert(hostMember);
      await loadDinners();

      const profile = { nickname: form.nickname, hometown: form.hometown };
      setMyProfile(profile);
      localStorage.setItem('my_profile_v2', JSON.stringify(profile));

      setSuccessType("create");
      setSuccessDinner(data[0]);
      go("success");
    } catch (e) {
      console.error('创建失败:', e);
      alert('创建失败: ' + e.message);
    }
  };

  if (loading) return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      minHeight: "100vh", 
      background: "#FDF6EC" 
    }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🏮</div>
        <div style={{ fontFamily: "'Noto Serif SC',serif", fontSize: 18, color: "#C41E24" }}>
          {error || "加载中..."}
        </div>
      </div>
    </div>
  );

  const currentDinner = dinners.find(d => d.id === targetId);

  return (
    <div style={{ 
      maxWidth: 430, 
      margin: "0 auto", 
      minHeight: "100vh", 
      background: "#FDF6EC", 
      fontFamily: "'Noto Sans SC',sans-serif", 
      position: "relative" 
    }}>
      <style>{`
        .fi { width:100%;padding:11px;border:1px solid #E8D5C0;border-radius:10px;font-size:14px;font-family:inherit;background:#FDF6EC;color:#2D1B10;outline:none;transition:border-color 0.2s;box-sizing:border-box; }
        .fi:focus { border-color:#C41E24; }
        .fi::placeholder { color:#9A8576; }
        select.fi { appearance:none;background-image:url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%239A8576' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 12px center; }
        @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;600;700;900&family=Noto+Sans+SC:wght@300;400;500;700&display=swap');
      `}</style>
      {screen === "home" && <HomeScreen dinners={dinners} onGo={go} />}
      {screen === "list" && <ListScreen dinners={dinners} onGo={go} onBack={() => go("home")} />}
      {screen === "detail" && <DetailScreen dinner={currentDinner} onGo={go} onBack={() => go("list")} myProfile={myProfile} />}
      {screen === "join" && <JoinScreen dinner={currentDinner} onBack={() => go("detail", targetId)} onSubmit={handleJoinSubmit} />}
      {screen === "create" && <CreateScreen onBack={() => go("home")} onSubmit={handleCreateSubmit} />}
      {screen === "success" && <SuccessScreen type={successType} dinner={successDinner} onHome={() => go("home")} />}
      {screen === "my" && <MyScreen onBack={() => go("home")} onGo={go} dinners={dinners} myProfile={myProfile} />}
    </div>
  );
}
